import { Box, Flex, Image, Text } from "@chakra-ui/react";
import LogoSagaAnimadoAzul from "../../assets/images/hero/icono-saga-azul.svg";
interface EmptyChatWelcomeProps {
  userName: string;
}
export const ChatWelcome: React.FC<EmptyChatWelcomeProps> = ({ userName }) => {
  return (
    <Flex justifyContent="center" alignItems="center" direction={"column"}>
      <Flex justifyContent="center" alignItems="center" pt={10}>
        <Image
          src={LogoSagaAnimadoAzul}
          alt="SAGA Fiscal"
          htmlWidth={100}
          htmlHeight={100}
          boxSize="100px"
          borderRadius="full"
          p={1}
          mb={3}
        />
      </Flex>

      <Text
        textAlign={"center"}
        fontSize="24px"
        fontWeight="500"
        maxW={"422px"}
        mb={16}
      >
        ¿En qué parte de tu operación fiscal puedo ayudarte ahora?
      </Text>
    </Flex>
  );
};

export default ChatWelcome;
